import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { RadioLabelText, Tooltip } from "@similarweb/ui-components";

import Input from "app/pages/activation/components/Input/Input";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon, midnight } = colorsPalettes;

export const EmailContainer = styled(FlexColumn)`
    padding-bottom: 24px;
    gap: 32px;
`;

export const SwitchWrapper = styled(FlexRow)`
    ${setFontVariant("body2")}

    gap: 6px;
    margin-bottom: 16px;
`;

export const SwitchLabel = styled.div`
    display: flex;
    cursor: pointer;
`;

export const RadioGroup = styled(FlexColumn)`
    gap: 8px;

    ${RadioLabelText} {
        font-size: 16px;
    }

    .emailGranularity {
        padding: 0;
    }
`;

export const RadioGroupTitle = styled.span`
    padding: 0;
    margin: 0 0 12px 0;
    ${setFontVariant("body1")};
`;

export const EmailInputContainer = styled.div`
    width: 300px;
`;

export const EmailInput = styled(Input)`
    input {
        box-shadow: unset;
        padding: 12px 16px;
        color: ${({ isDisabled }) => (isDisabled ? midnight[100] : carbon[500])};
        border: 1px solid ${midnight[50]};

        pointer-events: ${({ isDisabled }) => (isDisabled ? "none" : "auto")};
        cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "auto")};
    }
`;

export const Divider = styled.span`
    width: 348px;
    height: 1px;
    background: ${colorsPalettes.carbon[100]};
    margin-bottom: 24px;
`;

export const BetaBadgeWrapper = styled.div`
    display: flex;
    align-items: center;

    margin-right: 8px;
`;

export const BadgeIconWrapper = styled(FlexRow)`
    align-items: center;
    gap: 8px;

    margin-left: 8px;
`;

export const StyledTooltip = styled(Tooltip)`
    width: 198px;
`;
